import React, { ReactElement } from 'react';

export function RedirectPage(): ReactElement {
  let to = new URLSearchParams(window.location.search).get('url');
  if (!to || to[0] !== '/') {
    to = '/';
  }
  window.location.assign(to);
  return <></>;
}
